import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import useAuth from "src/hooks/useAuth";
import { bootIntercom, shutdownIntercom, updateIntercom } from "src/utils/intercom";

const glimpseAreaFor = (pathname) => (pathname.startsWith("/shopping") ? "shopping" : "main_app");

export default function IntercomMessenger() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const appId = user?.intercomMessenger?.appId;
  const glimpseArea = glimpseAreaFor(pathname);

  // The JWT is re-signed on every user refetch; read the latest without rebooting.
  const latest = useRef();
  latest.current = { jwt: user?.intercomMessenger?.jwt, glimpseArea };
  const lastPathname = useRef(pathname);

  // A Company switch is a different User, so it shuts down and boots a new Messenger session.
  useEffect(() => {
    if (!appId) return undefined;

    bootIntercom(appId, {
      intercom_user_jwt: latest.current.jwt,
      hide_default_launcher: true,
      glimpse_area: latest.current.glimpseArea,
    });
    return shutdownIntercom;
  }, [appId, user?.id]);

  useEffect(() => {
    if (!appId || lastPathname.current === pathname) return;

    lastPathname.current = pathname;
    updateIntercom({ intercom_user_jwt: latest.current.jwt, glimpse_area: glimpseArea });
  }, [appId, pathname, glimpseArea]);

  return null;
}
